<script setup lang="ts">
import { QItemLabel, QItemSection } from "quasar";
import { isString } from "vue-composable";
import MAvatar from "../../../../components/medicus/MAvatar";
import MItem from "../../../../components/medicus/MItem";
import { MenuGroup, MenuItem } from "../_types";

defineProps<{
  item: MenuItem | MenuGroup;
}>();
</script>
<template>
  <m-item
    class="sidebar-menu-item"
    v-bind="item"
    :to="item.to && isString(item.to) ? `/${$route.params.tenant}${item.to}` : item.to"
  >
    <q-item-label
      :class="[!item.to && !item.to && !item.toSlideover && !item.toModal && 'caption']"
    >
      <q-item-section>
        <m-avatar v-if="item.avatar" :name="item.avatar" workspace />
        <span
          :class="{ 'sidebar-menu-item--caption': !item.to && !item.toSlideover && !item.toModal }"
        >
          {{ item.label }}
        </span>
      </q-item-section>
    </q-item-label>
  </m-item>
  <template v-if="'items' in item">
    <q-separator />
    <SidebarMenuItem
      v-for="child in item.items"
      :key="`sidebar-menu-item-${item.label}--${child.label}`"
      :item="child"
    />
  </template>
</template>
<style lang="scss">
.sidebar-menu-item {
  .q-item__section {
    flex-wrap: nowrap;
    flex-direction: row;

    gap: 5px;

    .q-avatar {
      flex: 0 0 auto;
    }

    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
